import React, { useState } from 'react';
import WorkplaceFormOfCare from './WorkplaceFormOfCare';
import { SelectValue } from '../../../../Components/Base/Select/Select';

interface Props {
	name: string;
	isRequired?: boolean;
	placeholder?: string;
	value?: string;
}

const WorkplaceFormOfCarePHP: React.FC<Props> = ({ name, value }) => {
	const [val, setVal] = useState(value);
	const handleOnChange = (value: SelectValue) => {
		setVal(value?.value);
	};

	return (
		<>
			<WorkplaceFormOfCare value={val} onChange={handleOnChange} />
			<input
				style={{ display: 'none' }}
				name={name}
				value={val}
				onChange={() => {}}
			/>
		</>
	);
};

export default WorkplaceFormOfCarePHP;
